import React, { useEffect } from "react";

import { connect } from "react-redux";

import { useHistory } from "react-router-dom";

import { isLoginAuth } from "utils/common";

const Login = () => {
  let history = useHistory();

  useEffect(() => {
    if (!isLoginAuth()) {
      import("hfnauth/main")?.then(() => {
        document.querySelector("hfn-auth")?.triggerAuth();
      });
    } else {
      history.push("/");
    }
  }, [history]);

  return <div />;
};

const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default connect(mapStateToProps)(Login);
